import axios from "axios";

import { LoginParams, RefreshTokenParams } from "./paramsTypes";
import { LoginRes, RefreshTokenRes } from "./resTypes";

import { loginUrl, refreshTokenUrl, resetQrUrl } from "./urls";

import authHttpService from "core/http/singleton/auth";

import { REACT_APP_RESTFUL_BASE_URL_FOT_API } from "AppConfig";
import baseHttpService from "core/http/singleton/base";

export const loginApi = async (params: LoginParams): Promise<LoginRes> => {
  const res = await authHttpService.post<LoginRes>(loginUrl, params);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const refreshTokenApi = async (
  params: RefreshTokenParams
): Promise<RefreshTokenRes> => {
  const res = await axios.post<RefreshTokenRes>(refreshTokenUrl, params, {
    baseURL: REACT_APP_RESTFUL_BASE_URL_FOT_API,
  });
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const resetQrApi = async (formData: LoginParams) => {
  const res = await baseHttpService.post(resetQrUrl, formData);
  if (!res || !res.data) throw new Error("Opps");
  return res?.data;
};
